export default "__VITE_ASSET__DT06QdOH__"